import { render, staticRenderFns } from "./AppFourthScreen.vue?vue&type=template&id=562236a1&scoped=true"
import script from "./AppFourthScreen.vue?vue&type=script&lang=js"
export * from "./AppFourthScreen.vue?vue&type=script&lang=js"
import style0 from "./AppFourthScreen.vue?vue&type=style&index=0&id=562236a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562236a1",
  null
  
)

export default component.exports